import React, { useState } from 'react';
import { BsFacebook, BsInstagram, BsLinkedin, BsTwitter, BsYoutube } from 'react-icons/bs';
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoMdClose } from 'react-icons/io';
import { Link } from 'react-router-dom';
import PopUp from '../../pages/popup/PopUp';


const Hadear = () => {
  const [ismobile, setIsmobile] = useState(0);
  return (
    <>

      <nav className="navbar navbar-expand-lg sticky-top">
        <div className="container">
          <Link className="navbar-brand">
            <div className="logo-wrapper">
              <Link className='d-flex justify-content-center align-items-center' to="/">
                {/* <img src="assets/img/start-news-network-logo.jpeg" className="img-fluid" alt="Edusquad" /> */}
                {/* <img style={{ height: "110px", width: "220px", borderRadius: "5px" }} src="/assets/img/star_logo.JPEG" alt="logo" className="img-fluid" /> */}
                <img style={{ height: "80px", width: "180px", borderRadius: "px" }} src="https://res.cloudinary.com/dedml8dsw/image/upload/v1769051725/star_logo_nlerzd-removebg-preview_ae3grb.webp" alt="logo" className="img-fluid" />


              </Link>
            </div>
          </Link>
          <div className={ismobile ? "moblink" : "desklink"} onClick={() => setIsmobile(false)}>
            <ul>
              <Link className=" text-decoration-none" to="/">
                <li >होम</li>
              </Link>
              <Link className=" text-decoration-none" to="/about-us">
                <li className='li' >हमारे बारे में</li>
              </Link>
              <Link className=" text-decoration-none" to="/country">
                <li className='li' >देश</li>
              </Link>
              <li>
                <Link className=" text-decoration-none" to="/state">
                  <li> राज्य </li>
                </Link>
              </li>
              <li>
                <Link className=" text-decoration-none" to="/politics">
                  <li> राजनीति </li>
                </Link>
              </li>

              <li>
                <Link className=" text-decoration-none" to="/crime">
                  <li> अपराध</li>
                </Link>
              </li>
              <li>
                <Link className=" text-decoration-none" to="/world">
                  <li> विश्व</li>
                </Link>
              </li>
              <li>
                <Link className=" text-decoration-none" to="/breaking-news">
                  <li> ताजा ख़बरें</li>
                </Link>
              </li>
              <li>
                <Link className=" text-decoration-none" to="/business">
                  <li> व्यापार</li>
                </Link>
              </li>
              <li>
                <Link className=" text-decoration-none" to="/sports">
                  <li> खेल</li>
                </Link>
              </li>
              <li>
                <Link className=" text-decoration-none" to="/education">
                  <li> शिक्षा</li>
                </Link>
              </li>

            </ul>
          </div>

          <button className='vavbutn' onClick={() => setIsmobile(!ismobile)} style={{ marginBottom: "0px" }}>
            {ismobile ? < IoMdClose /> : < GiHamburgerMenu />}
          </button>
        </div>
      </nav>
    </>
  )
}
export default Hadear